import { render, staticRenderFns } from "./CleanersHeatmap.vue?vue&type=template&id=2c741363&scoped=true&lang=pug"
import script from "./CleanersHeatmap.vue?vue&type=script&lang=js"
export * from "./CleanersHeatmap.vue?vue&type=script&lang=js"
import style0 from "./CleanersHeatmap.vue?vue&type=style&index=0&id=2c741363&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c741363",
  null
  
)

export default component.exports